import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="bg-gray-200 text-black py-4">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row md:items-center md:justify-between">
        {/* Logo and Navigation Links */}
        <div className="mb-4 md:mb-0">
          <Link to="/" className="text-xl md:text-2xl font-extrabold tracking-tight block">
            intelleX CLMS
          </Link>
          <div className="flex flex-wrap mt-2 space-x-4 md:space-x-6">
            <Link
              to="/about"
              className="text-black hover:text-gray-700 transition duration-300"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-black hover:text-gray-700 transition duration-300"
            >
              Contact
            </Link>
            <Link
              to="/privacy"
              className="text-black hover:text-gray-700 transition duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-black hover:text-gray-700 transition duration-300"
            >
              Terms of Service
            </Link>
          </div>
        </div>
        
        {/* Social Icons */}
        <div className="flex justify-center md:justify-end space-x-4 mb-4 md:mb-0">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition duration-300"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition duration-300"
          >
            <FaTwitter />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition duration-300"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition duration-300"
          >
            <FaInstagram />
          </a>
        </div>
        
        {/* Contact Information */}
        <div className="flex flex-col md:flex-row items-center justify-center text-sm text-gray-500">
          <span className="flex items-center mb-2 md:mb-0">
            <MdEmail className="mr-2" /> info@intelleXclms.com
          </span>
          <span className="flex items-center">
            <MdPhone className="mr-2" /> +1 234 567 890
          </span>
          <span className="flex items-center">
            <MdLocationOn className="mr-2" /> 123 Street, City, Country
          </span>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="mt-4 text-center text-xs text-gray-500">
        &copy; {new Date().getFullYear()} intelleX CLMS. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
